export const formatNutritionNumber = value => {
  if (value == null || (typeof value === 'string' && value.trim() === '')) return '—';
  if (typeof value !== 'number' && typeof value !== 'string') return '—';
  const numeric = Number(value);
  return Number.isFinite(numeric) ? Math.round(numeric) : '—';
};
